import axios from 'axios';
import * as loadingActions from './loading.js';

export const loadBioStart = () => ({
  type: 'LOAD_BIO_START'
});

export const loadBioSuccess = contactData => ({
  type: 'LOAD_BIO_SUCCESS',
  payload: contactData
});

export const loadBioError = error => ({
  type: 'LOAD_BIO_ERROR',
  payload: error
});

export function loadBio() {
  return(dispatch, getState) => {
    dispatch(loadingActions.loadingData(getState().loading));
    axios.get('https://api.qiydaarpratt.com/api/v1/blocks').then((response)=>{
      dispatch(loadBioSuccess(response.data));
      dispatch(loadingActions.doneLoadingData(getState().loading));
    }).catch(error => dispatch(loadBioError(error)));
  }
}



// WEBPACK FOOTER //
// ./src/actions/bio.js